import React from 'react';
import { graphql, Link } from 'gatsby';
import kebabCase from 'lodash/kebabCase';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import Layout from '@components/layout';

const StyledTagsPage = styled.main`
  max-width: 1000px;

  ul {
    li {
      font-size: 24px;

      a {
        color: var(--light-slate);
      }

      .count {
        color: var(--slate);
        font-size: var(--fz-sm);
        margin-left: 8px;
      }
    }
  }
`;

const BlogTagsPage = ({ data, location }) => {
  const tags = data?.allMarkdownRemark?.group || [];

  return (
    <Layout location={location}>
      <Helmet title="Blog Tags" />

      <StyledTagsPage>
        <span className="breadcrumb">
          <span className="arrow">&larr;</span>
          <Link to="/blog">All posts</Link>
        </span>

        <h1 className="big-heading">Tags</h1>

        {tags.length === 0 ? (
          <p>No tags found.</p>
        ) : (
          <ul className="fancy-list">
            {tags.map(tag => (
              <li key={tag.fieldValue}>
                <Link to={`/blog/tags/${kebabCase(tag.fieldValue)}/`}>#{tag.fieldValue}</Link>
                <span className="count">{tag.totalCount} posts</span>
              </li>
            ))}
          </ul>
        )}
      </StyledTagsPage>
    </Layout>
  );
};

BlogTagsPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      group: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string.isRequired,
          totalCount: PropTypes.number.isRequired,
        }),
      ),
    }),
  }).isRequired,
  location: PropTypes.object,
};

export default BlogTagsPage;

export const pageQuery = graphql`
  query {
    allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/content/posts/" }
        frontmatter: { draft: { ne: true } }
      }
    ) {
      group(field: { frontmatter: { tags: SELECT } }) {
        fieldValue
        totalCount
      }
    }
  }
`;